import Vue from "vue";
import axios from "axios";

Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
const getController = self.customSetting.getFineMgmt;
// const postController = self.customSetting.postFineMgmt;

export default {
  QryFineData: () => {
    return axios.get(`${baseApi}/${getController}/QryFineData`);
  },
  QryFineDetail: (context, sid) => {
    return axios.get(`${baseApi}/${getController}/QryFineDetail?sid=${sid}`);
  },
  QryFineInfo: (context, fineId) => {
    return axios.get(
      `${baseApi}/${getController}/QryFineInfo?fineId=${fineId}`
    );
  },
};
